import { CONTACTO, NAV_LINKS, waLink } from "@/data/content";
import { useCertero } from "@/context/CerteroContext";

export default function Footer() {
  const { scrollToId, setPrivacyOpen } = useCertero();
  return (
    <footer className="border-t border-hud bg-ink px-4 pb-10 pt-16 sm:px-8 lg:px-12" data-testid="footer">
      <div className="mx-auto max-w-[1400px]">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <img src="/logo-isotipo.svg" alt="Isotipo CERTERO SRL" className="h-10 w-auto" loading="lazy" />
              <div className="leading-none">
                <p className="font-display text-lg font-extrabold tracking-wide text-mist">CERTERO <span className="font-normal">SRL</span></p>
                <p className="mt-1 font-mono text-[9px] uppercase tracking-[0.3em] text-certero">
                  DJI Agriculture · Bolivia
                </p>
              </div>
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-smoke">
              Drones agrícolas DJI Agriculture, servicios, soporte técnico y capacitación para una
              nueva generación de agricultura.
            </p>
          </div>

          <nav aria-label="Secciones del sitio">
            <h3 className="font-mono text-[10px] uppercase tracking-[0.25em] text-certero">Secciones</h3>
            <ul className="mt-5 grid grid-cols-2 gap-x-6 gap-y-3">
              {NAV_LINKS.concat([{ id: "contacto", label: "Contacto" }]).map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollToId(l.id)}
                    className="text-sm text-smoke transition-colors duration-300 hover:text-mist"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="font-mono text-[10px] uppercase tracking-[0.25em] text-certero">Contacto</h3>
            <ul className="mt-5 flex flex-col gap-3 text-sm text-smoke">
              <li>{CONTACTO.direccion}, {CONTACTO.ciudad}</li>
              <li>
                Mañana {CONTACTO.horarioManana} · Tarde {CONTACTO.horarioTarde}
              </li>
              <li>
                <a href={`https://wa.me/${CONTACTO.whatsapp}`} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" className="transition-colors duration-300 hover:text-mist">
                  WhatsApp {CONTACTO.whatsappDisplay}
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACTO.email}`} className="transition-colors duration-300 hover:text-mist">
                  {CONTACTO.email}
                </a>
              </li>
              <li className="flex flex-wrap gap-4 pt-2">
                {CONTACTO.redes.map((r) => (
                  <a
                    key={r.nombre}
                    data-testid={r.testid}
                    href={r.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="border border-hud px-4 py-2 text-[10px] uppercase tracking-[0.2em] text-mist/70 transition-[border-color,color] duration-300 hover:border-certero hover:text-certero"
                  >
                    {r.nombre}
                  </a>
                ))}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-hud/60 pt-7 sm:flex-row sm:items-center">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-smoke/60">
            © 2026 CERTERO SRL — Santa Cruz de la Sierra, Bolivia
          </p>
          <div className="flex items-center gap-6">
            <button
              data-testid="footer-privacidad"
              onClick={() => setPrivacyOpen(true)}
              className="font-mono text-[10px] uppercase tracking-[0.2em] text-smoke/60 transition-colors duration-300 hover:text-mist"
            >
              Política de privacidad
            </button>
            <a
              data-testid="footer-admin-link"
              href="/admin"
              className="font-mono text-[10px] uppercase tracking-[0.2em] text-smoke/40 transition-colors duration-300 hover:text-smoke"
            >
              Acceso interno
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
